import React from "react";
import { Eyebrow } from "./Bits.jsx";

export const emptyLedger = () => ({
  rows: [{ element: "", human: "", machine: "", verification: "" }],
  models: "", cycles: "", prompt: "", wrong: "", signed: false,
});

export default function LedgerEditor({ value, onChange, readOnly }) {
  const led = value ?? emptyLedger();
  const set = (patch) => onChange({ ...led, ...patch });
  const setRow = (i, patch) => set({ rows: led.rows.map((r, j) => (j === i ? { ...r, ...patch } : r)) });

  if (readOnly) {
    return (
      <table>
        <thead><tr><th>Element</th><th>Human</th><th>Machine</th><th>Verified</th></tr></thead>
        <tbody>{led.rows.map((r, i) => (
          <tr key={i}><td>{r.element}</td><td>{r.human}</td><td>{r.machine}</td><td>{r.verification}</td></tr>
        ))}</tbody>
      </table>
    );
  }

  return (
    <div>
      {led.rows.map((r, i) => (
        <div className="card" key={i} style={{ marginBottom: 10, background: "#fff" }}>
          <Eyebrow>Element {i + 1}</Eyebrow>
          <input type="text" placeholder="What part of the work is this?" value={r.element}
            style={{ marginTop: 6 }} onChange={(e) => setRow(i, { element: e.target.value })} />
          <div style={{ display: "grid", gap: 6, gridTemplateColumns: "1fr", marginTop: 6 }}>
            <input type="text" placeholder="What you did" value={r.human} onChange={(e) => setRow(i, { human: e.target.value })} />
            <input type="text" placeholder="What the machine did" value={r.machine} onChange={(e) => setRow(i, { machine: e.target.value })} />
            <input type="text" placeholder="How you verified it" value={r.verification} onChange={(e) => setRow(i, { verification: e.target.value })} />
          </div>
        </div>
      ))}
      <button className="btn ghost" onClick={() => set({ rows: [...led.rows, { element: "", human: "", machine: "", verification: "" }] })}>
        + add element
      </button>

      <div style={{ display: "grid", gap: 8, marginTop: 12 }}>
        <input type="text" placeholder="Models and tools used" value={led.models} onChange={(e) => set({ models: e.target.value })} />
        <input type="text" placeholder="Approximate prompt cycles" value={led.cycles} onChange={(e) => set({ cycles: e.target.value })} />
        <textarea rows={2} placeholder="Your highest-leverage prompt, verbatim" value={led.prompt} onChange={(e) => set({ prompt: e.target.value })} />
      </div>

      <div className="warn" style={{ marginTop: 12 }}>
        <Eyebrow style={{ color: "var(--madder)" }}>The field faculty read first</Eyebrow>
        <textarea rows={3} style={{ marginTop: 6 }} value={led.wrong}
          placeholder="One place the machine was wrong, and how you caught it."
          onChange={(e) => set({ wrong: e.target.value })} />
        <p style={{ fontSize: 12, color: "var(--graphite)", margin: "6px 0 0" }}>
          {led.wrong.trim().length}/40 characters minimum. A blank field fails L1 and returns the submission —
          not as a punishment, but because it means nothing was verified.
        </p>
      </div>

      <label style={{ display: "flex", gap: 8, marginTop: 12, fontSize: 14 }}>
        <input type="checkbox" checked={!!led.signed} onChange={(e) => set({ signed: e.target.checked })} />
        <span>I attest that this record is accurate and complete.</span>
      </label>
    </div>
  );
}
